<section
  class="relative min-w-0"
  aria-labelledby="catalog-trending-heading"
  [attr.aria-busy]="isLoading"
  data-swipe-navigation-ignore
>
  <div
    #columnGrid
    class="pointer-events-none invisible absolute inset-x-0 top-0 h-0"
    [ngClass]="gridClasses"
    aria-hidden="true"
  ></div>
  <div class="mb-1 flex items-center justify-between gap-1">
    <h2
      id="catalog-trending-heading"
      class="!m-0 !max-w-none !text-[20px] mobile:!text-[22px] !leading-[28px]"
    >
      {{ "CATALOG_SEARCH_TRENDING" | translate }}
    </h2>
    <div
      class="ml-auto flex shrink-0 gap-0.5 has-[.swiper-button-lock]:hidden"
      [class.hidden]="isLoading || hasError || !works.length"
    >
      <button
        #previousButton
        appPointerHover
        type="button"
        class="flex h-[24px] w-[32px] cursor-pointer items-center justify-center rounded-md bg-black/5 text-black transition-opacity dark:bg-white/5 dark:text-white [&.is-pointer-hovered]:bg-black/10 dark:[&.is-pointer-hovered]:bg-white/10 [&.swiper-button-disabled]:pointer-events-none [&.swiper-button-disabled]:opacity-30 [&.swiper-button-lock]:hidden"
        [attr.aria-label]="'PREVIOUS_WORK' | translate"
      >
        <span
          aria-hidden="true"
          class="block h-[16px] w-[16px] rotate-180 bg-current mask-[url(/assets/images/icons/chevron-right.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        ></span>
      </button>
      <button
        #nextButton
        appPointerHover
        type="button"
        class="flex h-[24px] w-[32px] cursor-pointer items-center justify-center rounded-md bg-black/5 text-black transition-opacity dark:bg-white/5 dark:text-white [&.is-pointer-hovered]:bg-black/10 dark:[&.is-pointer-hovered]:bg-white/10 [&.swiper-button-disabled]:pointer-events-none [&.swiper-button-disabled]:opacity-30 [&.swiper-button-lock]:hidden"
        [attr.aria-label]="'NEXT_WORK' | translate"
      >
        <span
          aria-hidden="true"
          class="block h-[16px] w-[16px] bg-current mask-[url(/assets/images/icons/chevron-right.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        ></span>
      </button>
    </div>
  </div>
  @if (isLoading) {
  <div
    class="py-1"
    [ngClass]="gridClasses"
    [style.grid-template-columns]="isMobile ? 'repeat(2,minmax(0,1fr))' : null"
    [attr.aria-label]="'LOADING' | translate"
  >
    @for (placeholder of placeholders; track placeholder) {
    <div class="max-w-[200px] animate-pulse">
      <div class="aspect-[2/3] rounded-lg bg-black/5 dark:bg-white/10"></div>
      <div class="mt-1 h-2 w-3/4 rounded bg-black/5 dark:bg-white/10"></div>
    </div>
    }
  </div>
  } @else if (hasError) {
  <div class="my-2" role="alert">
    <p class="mb-1 text-sm text-grey dark:text-borders-dark">
      {{ "ERROR_OCCURED_SEARCH" | translate }}
    </p>
    <button
      type="button"
      class="btn btn-transparent btn-small"
      (click)="reload()"
    >
      {{ "CATALOG_ADD_SEARCH_RETRY" | translate }}
    </button>
  </div>
  } @else if (!works.length) {
  <p class="my-2 text-sm text-grey dark:text-borders-dark">
    {{ "CATALOG_SEARCH_TRENDING_EMPTY" | translate }}
  </p>
  }
  <swiper-container
    #trendingSwiper
    init="false"
    class="cards-list block min-w-0 w-full [&::part(container)]:py-1"
    [class.hidden]="isLoading || hasError || !works.length"
  >
    @for (work of works; track work.type + ':' + work._id) {
    <swiper-slide class="!h-auto">
      <app-work-card
        [item]="work"
        [type]="work.type"
        [user]="user"
        [isMobile]="isMobile"
        [catalogSearch]="true"
        [modalNavigationContext]="modalNavigationContext"
        [dimUnowned]="false"
        [hasMultipleTypes]="hasMultipleTypes"
      />
    </swiper-slide>
    }
  </swiper-container>
</section>
